import styled, { css } from 'styled-components'

import { CommonButton } from 'components/Button'
import { WhiteBlock } from 'components/Layout/CommonBlocks'
import theme from 'theme_'
import { Body12, Font14, Font16 } from 'components/Typography'

export const ProcessesStatusLabel = styled.div<{ isRunning: boolean }>`
  ${(p) =>
    p.isRunning
      ? `color: ${theme.colors.green}`
      : `color: ${theme.colors.horizonOrange}`}
`

export const StyledProcessActionCell = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

const disabledProcessActionCss = css`
  filter: grayscale(1);
  opacity: 0.7;
`

export const ProcessesRowActionIcon = styled.img<{
  size?: number
  $disabled?: boolean
}>`
  display: flex;
  align-items: center;
  width: ${(p) => (p.size ? `${p.size}px` : '32px')};
  height: ${(p) => (p.size ? `${p.size}px` : '32px')};
  cursor: pointer;
  ${(p) => p.$disabled && disabledProcessActionCss};
  padding: 8px;
`

export const ProcessesSystemMonitorHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${theme.spacing.s} 0;

  @media ${theme.devices.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`

export const ProcessesSystemMonitorHeaderButtons = styled.div`
  display: flex;
  align-items: center;
`

export const ProcessesResetHardwareButton = styled(CommonButton)`
  margin: 16px;
`
export const ProcessesSearchBox = styled.div`
  margin-bottom: 15px;
`

export const ProcessesTableMonitorContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-content: space-between;
  justify-content: space-between;
  align-items: flex-start;
`

export const ProcessesTableMonitorItem = styled.div`
  flex: 1 1 auto;
`

export const ProcessesTableInfoItem = styled(WhiteBlock)`
  position: sticky;
  top: 80px;
  display: flex;
  flex: 0 1 20%;
  flex-flow: column;
  align-content: stretch;
  max-height: 75vh;
  overflow-y: scroll;
  margin-left: 15px;
`

export const ProcessesTableInfoItemHeader = styled.div`
  flex: 0 1 auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 15px;
`
export const ProcessesTableInfoItemBodyItem = styled.div`
  flex: 0 1 auto;
  font-weight: bold;
  ${Font16};
  color: ${theme.colors.otterWarmBlack};
  margin-bottom: 15px;
`

export const ProcessInfoLabel = styled.div`
  font-weight: bold;
  ${Font14};
  word-break: break-word;
  color: ${theme.colors.moreGrey};
`

export const ProcessInfoRowLabel = styled(ProcessInfoLabel)`
  flex: 1 1 100%;
  font-weight: bold;
  margin-bottom: 15px;
`

export const ProcessInfoNameLabel = styled(ProcessInfoLabel)`
  flex: 1 1 100%;
  margin-bottom: 15px;
  background: ${theme.colors.hover10};
  border-radius: 8px;
  order: 0;
  align-self: stretch;
  margin: 16px 0px;
  padding: 8px;
  font-weight: bold;
  ${Font16};
  color: ${theme.colors.otterWarmBlack};
  overflow: hidden;
`

export const ProcessesTableInfoItemRow = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 15px;
`
export const ProcessesTableInfoActionItemRow = styled.div`
  flex: 0 1 auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin-bottom: 15px;
`

export const ProcessInfoMobilePopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  padding-bottom: 0px;
  background: ${theme.colors.grey};
  animation: ${theme.animations.fadeIn} 0.2s ease;
  transition: all 0.2s ease;
`

export const ProcessInfoMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  padding-bottom: 16px;
  bottom: 0;
`
export const ProcessInfoCloseButton = styled(CommonButton)`
  width: auto;
`

export const ProcessesStatsContainer = styled.div`
  display: flex;
  max-height: 75vh;
  overflow-y: scroll;
  flex-flow: column;
  align-content: stretch;
  margin: ${theme.spacing.base} 0;
  padding: 12px 16px;
  border-radius: ${theme.spacing.xs};
  border: 1px solid ${theme.colors.pelicanGrey};
  background-color: ${theme.colors.newGrey};

  @media ${theme.devices.tablet} {
    position: sticky;
    top: 80px;
    flex: 0 1 20%;
    margin: 0 0 0 15px;
  }
`

export const ProcessesStatsList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2%;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    gap: 0;
  }
`

export const ProcessesStatsTitle = styled.div`
  margin-bottom: ${theme.spacing.md};
  color: ${theme.colors.moreGrey};
`

export const StyledProcessesStatsItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 23%;
  font-weight: 700;
  margin-bottom: ${theme.spacing.md};

  @media ${theme.devices.tablet} {
    width: 100%;
  }
`

export const ProcessesStatsSubtitle = styled(Body12)`
  color: ${theme.colors.moreGrey};
  margin-bottom: 6px;
  font-weight: 400;
`
